import ConversationApiClient from '../api/conversations';

// Bulk Export Helper - Uses the working single export to create bulk export functionality
export const bulkExportConversations = async (conversationIds) => {
  const csvContents = [];
  const results = [];
  
  for (const id of conversationIds) {
    try {
      const response = await ConversationApiClient.export(id);
      
      if (response.status === 200) {
        // Convert blob to text
        const csvText = await response.data.text();
        csvContents.push(csvText);
        results.push({ id, status: 'success' });
      } else {
        results.push({ id, status: 'failed', error: response.status });
      }
    } catch (error) {
      results.push({ id, status: 'error', error: error.message });
    }
  }
  
  // Combine all CSV contents into one file
  if (csvContents.length > 0) {
    const combinedCSV = combineCSVFiles(csvContents);
    downloadCSVFile(combinedCSV, `conversations_bulk_export_${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.csv`);
  }
  
  return results;
};

// Export All Conversations Helper - Fetches all conversations and exports them
export const exportAllConversations = async () => {
  try {
    console.log('Starting export all conversations...');
    
    // First, get all conversation IDs
    const allConversationIds = await getAllConversationIds();
    
    console.log('Total conversation IDs found:', allConversationIds.length);
    
    if (allConversationIds.length === 0) {
      console.log('No conversation IDs found, returning error');
      return { success: false, message: 'No conversations found to export.' };
    }
    
    console.log('Starting bulk export for', allConversationIds.length, 'conversations');
    
    // Then export all conversations using the existing bulk export helper
    const results = await bulkExportConversations(allConversationIds);
    
    const successCount = results.filter(r => r.status === 'success').length;
    const failureCount = results.filter(r => r.status !== 'success').length;
    
    console.log('Export completed. Success:', successCount, 'Failed:', failureCount);
    
    return {
      success: true,
      totalConversations: allConversationIds.length,
      successCount,
      failureCount,
      results
    };
  } catch (error) {
    console.error('Error in exportAllConversations:', error);
    return { success: false, message: error.message };
  }
};

// Helper function to get all conversation IDs
const getAllConversationIds = async () => {
  const allIds = [];
  let page = 1;
  let hasMorePages = true;
  
  while (hasMorePages) {
    try {
      const response = await ConversationApiClient.getAllConversations({ page });
      console.log('API Raw Response (axios object):', response);
      console.log('API Response data (response.data):', response.data);
      console.log('Type of response.data:', typeof response.data);
      
      let conversations = [];
      let potentialPayload = null;

      if (response.data && response.data.data) {
        potentialPayload = response.data.data.payload;
        console.log('Attempting path: response.data.data.payload');
      } else if (response.data) {
        potentialPayload = response.data.payload;
        console.log('Attempting path: response.data.payload');
      }

      if (Array.isArray(potentialPayload)) {
        conversations = potentialPayload;
        console.log('Successfully extracted conversations array.');
      } else {
        console.log('Failed to extract conversations array. potentialPayload:', potentialPayload, 'Type:', typeof potentialPayload);
      }

      console.log('Extracted conversations array:', conversations);
      console.log('Number of conversations on this page:', conversations.length);
      
      if (conversations.length === 0) {
        console.log('No more conversations or empty array extracted, stopping pagination.');
        hasMorePages = false;
      } else {
        conversations.forEach((conversation, index) => {
          const conversationId = conversation.id || conversation.display_id || conversation.conversation_id;
          if (conversationId) {
            allIds.push(conversationId);
          }
          console.log(`Processed conversation ${index}, ID: ${conversationId}, Total IDs collected: ${allIds.length}`);
        });
        page++;
      }
    } catch (error) {
      console.error('Error fetching conversations page:', page, error);
      hasMorePages = false;
    }
  }
  console.log('Final total conversation IDs found:', allIds.length, allIds);
  return allIds;
};

// Function to combine multiple CSV files into one
const combineCSVFiles = (csvContents) => {
  if (csvContents.length === 0) return '';
  
  // Get headers from first file
  const firstFile = csvContents[0];
  const lines = firstFile.split('\n');
  const headers = lines[0];
  
  // Combine all data rows
  let combinedData = headers + '\n';
  
  csvContents.forEach((csvContent) => {
    const lines = csvContent.split('\n');
    // Skip header row and add data rows
    for (let i = 1; i < lines.length; i++) {
      if (lines[i].trim()) {
        combinedData += lines[i] + '\n';
      }
    }
  });
  
  return combinedData;
};

// Function to download CSV file
const downloadCSVFile = (csvContent, filename) => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('download', filename);
  link.setAttribute('href', url);
  link.click();
  URL.revokeObjectURL(url);
}; 